import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Facebook, Home, Users, Grid, UserCheck, Trello, HelpCircle, Bookmark, Settings, LogOut } from "react-feather";
import logo from '../../../component/img/logo3.jpg';

const Sidebar = () => {
  const location = useLocation(); // Get the current location

  // Function to check if a route is active
  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="">
          <img src={logo} className="img-fluid logo" alt="A2Z Yatra Logo" />
        </div>
      </div>
      <ul className="sidebar-menu">
        <li className={isActive("/admin-dashboard") ? "active" : ""}>
          <Link to="/admin-dashboard" className="kp">
            <Home className="ic" />
            <span>Dashboard</span>
          </Link>
        </li>

        <li className={isActive("/booking-enquiry") ? "active" : ""}>
          <Link to="/booking-enquiry" className="kp">
            <HelpCircle className="ic" />
            <span>Booking Enquiry</span>
          </Link>
        </li>

        <li className={isActive("/add-distributors") ? "active" : ""}>
          <Link to="/add-distributors" className="kp">
            <UserCheck className="ic" />
            <span>State Head</span>
          </Link>
        </li>

        <li className={isActive("/admin/agent-payment-request") ? "active" : ""}>
          <Link to="/admin/agent-payment-request" className="kp">
            <UserCheck className="ic" />
            <span>Agent Payment Request</span>
          </Link>
        </li>

        <li className={isActive("/admin/state-head-payment-request") ? "active" : ""}>
          <Link to="/admin/state-head-payment-request" className="kp">
            <UserCheck className="ic" />
            <span>StateHead Request</span>
          </Link>
        </li>

        
        <li className={isActive("/admin-packages") ? "active" : ""}>
          <Link to="/admin-packages" className="kp">
            <Grid className="ic" />
            <span>Packages</span>
          </Link>
        </li>

        {/* <li className={isActive("/admin-hotel-booking-report") ? "active" : ""}>
          <Link to="/admin-hotel-booking-report" className="kp">
            <Bookmark className="ic" />
            <span>Bookings</span>
          </Link>
        </li> */}


        <li className={isActive("/admin/hotel-markup") ? "active" : ""}>
          <Link to="/admin/hotel-markup" className="kp">
            <Users className="ic" />
            <span>Give CashBack</span>
          </Link>
        </li>


        <li className={isActive("/all-staff") ? "active" : ""}>
          <Link to="/all-staff" className="kp">
            <Users className="ic" />
            <span>Staff / Admins</span>
          </Link>
        </li>

        <li className={isActive("/social-links") ? "active" : ""}>
          <Link to="/social-links" className="kp">
            <Facebook className="ic" />
            <span>Social Media</span>
          </Link>
        </li>


        <li className={isActive("/admin-hotel-booking-report") ? "active" : ""}>
          <Link to="/admin-hotel-booking-report" className="kp">
            <Trello className="ic" />
            <span>Reports</span>
          </Link>
        </li>

        <li className={isActive("/add-flight-code") ? "active" : ""}>
          <Link to="/add-flight-code" className="kp">
            <Trello className="ic" />
            <span>Add Flight Code</span>
          </Link>
        </li>


        <li className={isActive("/add-admin-markup") ? "active" : ""}>
          <Link to="/add-admin-markup" className="kp">
            <Trello className="ic" />
            <span>Admin Markup</span>
          </Link>
        </li>

        

<hr/>
        <li className={isActive("/admin-change-password") ? "active" : ""}>
          <Link to="/admin-change-password" className="kp">
            <Settings className="ic" />
            <span>Change Password</span>
          </Link>
        </li>


        <li>
          <Link   className="kp">
            <LogOut className="ic" />
            <span>Logout</span>
          </Link>
        </li>

        



        



        {/* <li className={isActive("/users") ? "active" : ""}>
          <Link to="/users" className="kp">
            <Grid className="ic" />
            <span>All Event</span>
          </Link>
        </li> */}
        
         
      </ul>
 
    </div>
  );
};

export default Sidebar;
